// Gravar o carrinho. Passar SEMPRE por aqui em vez de chamar localStorage
// directamente.
//
// PORQUE: o carrinho vive no localStorage e o icone da barra do topo (App.jsx)
// le-o de la. O evento 'storage' nativo do browser so dispara nas OUTRAS abas —
// nunca na aba que escreveu. Por isso quem grava tem de avisar a mao.
//
// Havia seis sitios a gravar e nenhum avisava: o contador ficava preso no valor
// lido no arranque da pagina. Depois de submeter uma encomenda o carrinho
// esvaziava, mas o icone continuava a mostrar as unidades da encomenda anterior.
export function guardarCarrinho(itens) {
  const arr = Array.isArray(itens) ? itens : []
  localStorage.setItem('carrinho', JSON.stringify(arr))
  window.dispatchEvent(new Event('storage'))
  return arr
}
